import { tokensLabel } from './tokens'

// Artemis credit packs (WEB-7135, API-3799, API-3800): bought on the web through services' Stripe
// Checkout, spent by Artemis once the month's allowance is used. Packs are data-driven in services
// (ArtemisCreditProduct); until its endpoint answers, the page shows the packs WEB-7135 names so the
// page can be reviewed, with buying off.

// Proposed services contract (API-3799, to confirm with services):
//   GET  api/v1/Payment/CreditProducts → [{ Id, PriceUsd, CreditUsd, ValidDays }]
//   POST api/v1/Payment/CreditLink { ProductId, SuccessUrl, CancelUrl } → { Url } (a Stripe Checkout Session)
export const FALLBACK_PACKS = [
  { id: null, priceUsd: 10, creditUsd: 5, validDays: 365 },
  { id: null, priceUsd: 25, creditUsd: 12.5, validDays: 365 }
]

const num = v => (typeof v === 'number' && Number.isFinite(v) ? v : Number.isFinite(Number(v)) && v !== '' && v != null ? Number(v) : null)

// Products as packs, cheapest first; null when services returned nothing usable.
export const packsFrom = products => {
  const list = Array.isArray(products) ? products : (products && Array.isArray(products.Items) ? products.Items : null)
  if (!list) return null
  const packs = list
    .map(p => ({ id: p.Id ?? p.id ?? null, priceUsd: num(p.PriceUsd ?? p.priceUsd), creditUsd: num(p.CreditUsd ?? p.creditUsd), validDays: num(p.ValidDays ?? p.validDays) }))
    .filter(p => p.id != null && p.priceUsd > 0 && p.creditUsd > 0)
    .sort((a, b) => a.priceUsd - b.priceUsd)
  return packs.length ? packs : null
}

const dollars = usd => (Number.isInteger(usd) ? `$${usd}` : `$${usd.toFixed(2)}`)
const capital = s => s.charAt(0).toUpperCase() + s.slice(1)

// "$10" / "About 2.4M input and 77K output tokens" / "Good for 365 days": the pack's price, and what it
// buys as tokens (rates from tokens.js), never its dollar value, which would show the margin.
export const packLabels = (pack, rates) => ({
  price: dollars(pack.priceUsd),
  credit: capital(tokensLabel(pack.creditUsd, rates)),
  valid: pack.validDays ? `Good for ${pack.validDays} days` : null
})

// Where Stripe sends the user back: this page, saying how it went.
export const checkoutUrls = origin => ({
  SuccessUrl: `${origin}/artemis/credits?purchase=success`,
  CancelUrl: `${origin}/artemis/credits?purchase=cancelled`
})

// 'success' | 'cancelled' | null, from the return URL's query.
export const purchaseResult = search => {
  const v = new URLSearchParams(search || '').get('purchase')
  return v === 'success' || v === 'cancelled' ? v : null
}
